module.exports = __webpack_public_path__ + "img/athlete1.07059a64.png";